/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalReauthSubmission } from './PalReauthSubmission';
import {
    PalReauthSubmissionFromJSON,
    PalReauthSubmissionFromJSONTyped,
    PalReauthSubmissionToJSON,
} from './PalReauthSubmission';

/**
 * 
 * @export
 * @interface PalReauthSubmissionHistoryResponse
 */
export interface PalReauthSubmissionHistoryResponse {
    /**
     * 
     * @type {Array<PalReauthSubmission>}
     * @memberof PalReauthSubmissionHistoryResponse
     */
    reauth_submissions: Array<PalReauthSubmission>;
}

/**
 * Check if a given object implements the PalReauthSubmissionHistoryResponse interface.
 */
export function instanceOfPalReauthSubmissionHistoryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reauth_submissions" in value;

    return isInstance;
}

export function PalReauthSubmissionHistoryResponseFromJSON(json: any): PalReauthSubmissionHistoryResponse {
    return PalReauthSubmissionHistoryResponseFromJSONTyped(json, false);
}

export function PalReauthSubmissionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionHistoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reauth_submissions': ((json['reauth_submissions'] as Array<any>).map(PalReauthSubmissionFromJSON)),
    };
}

export function PalReauthSubmissionHistoryResponseToJSON(value?: PalReauthSubmissionHistoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reauth_submissions': ((value.reauth_submissions as Array<any>).map(PalReauthSubmissionToJSON)),
    };
}

